export default __webpack_public_path__ + "static/media/screen3.eaf9b85d.png";